export default "__VITE_ASSET__66c008c2__"